import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ChatEarlyShowMatch from './ChatEarlyShowMatch';
import { earlyShowCandidates, finalPodcastShows, normalizeEarlyShowMatch, sameEarlyShowIdentity } from '../utils/chatEarlyShowMatch';

// The route keeps this component keyed by runId through the live-to-saved handoff.
// Accept the first live match, or a saved match when opening an existing answer.
// Terminal updates cannot introduce or replace a suggestion during this visit.
export default function ChatAssistantTurn({ engineVersion, earlyShowMatch, runId, runStatus = 'complete', sections, children }) {
    const navigate = useNavigate();
    const incoming = engineVersion === 3 ? normalizeEarlyShowMatch(earlyShowMatch) : null;
    const match = incoming?.runId === runId ? incoming : null;
    const active = runStatus === 'queued' || runStatus === 'running';
    const [accepted, setAccepted] = useState(() => ({ match, finished: !active }));
    const [expanded, setExpanded] = useState(false);
    const [interaction, setInteraction] = useState({ held: false, finalShows: [] });

    if (!accepted.finished && !active) {
        setAccepted({ ...accepted, finished: true });
    } else if (!accepted.finished && !accepted.match && match) {
        setAccepted({ ...accepted, match });
    }

    const finalShows = runStatus === 'complete' ? finalPodcastShows(sections) : [];
    const reconciledShows = interaction.held ? interaction.finalShows : finalShows;
    const candidates = earlyShowCandidates(accepted.match)
        .filter((candidate) => !reconciledShows.some((show) => sameEarlyShowIdentity(candidate.show, show)));

    return <>
        <ChatEarlyShowMatch candidates={candidates}
            retained={accepted.finished}
            expanded={expanded} onExpandedChange={setExpanded}
            onOpen={({ pathname, state }) => navigate(pathname, { state })}
            onInteractionChange={({ focused, pointedAt }) => {
                const held = focused || pointedAt;
                // Keep both the row and its position stable during interaction.
                // Reconcile final cards once the user leaves.
                setInteraction((previous) => previous.held === held ? previous : {
                    held, finalShows,
                });
            }} />
        {typeof children === 'function' ? children({ hasEarlyShowMatch: active && candidates.length > 0 }) : children}
    </>;
}
